import { ApolloClient, InMemoryCache } from '@apollo/client';

// uri: 'https://todo-list-backed.herokuapp.com/graphql',
export const client = new ApolloClient({
  ssrMode: true,
  uri: 'https://todo-list-backed.herokuapp.com/graphql',
  cache: new InMemoryCache(),
});
